import { render, staticRenderFns } from "./UserNameRegExpSetupView.vue?vue&type=template&id=85dedfc6&scoped=true&"
import script from "./UserNameRegExpSetupView.vue?vue&type=script&lang=ts&"
export * from "./UserNameRegExpSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dedfc6",
  null
  
)

export default component.exports